// extracted by mini-css-extract-plugin
export default {"layout":"_404_layout__RMNoo","layout__content":"_404_layout__content__K+JSu"};